// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2-gSl","header":"style_header__2UoYW","content":"style_content__Rd7-C"};